import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import ContactForm from "../../components/ContactFrom/ContactForm";
import RelatedProject from "./related";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Footer from "../../components/footer/Footer";
import Navbar2 from "../../components/Navbar2/Navbar2";
import img from "../../images/raw-coffee.jpg";
import StarLoader from "../../components/loader/StarLoader";

const ProjectSinglePage = () => {
  const { id } = useParams();
  const [projectDetails, setProjectDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState(null);
  const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/projects-list/${id}`);
        const data = await response.json();
        setProjectDetails(data);
        setMainImage(data.banner);
      } catch (error) {
        console.error("Error fetching project:", error);
      } finally {
        setLoading(false); // ✅ stop loader only after fetch is complete
      }
    };

    fetchProject();
  }, [id, apiUrl]);

  // 👇 Show loader while loading is true, else show the full page
  if (loading) {
    return <StarLoader />;
  }

  if (!projectDetails) {
    return (
      <p style={{ textAlign: "center", padding: "50px" }}>Project not found</p>
    );
  }

  const imagesArray = projectDetails.images
    ? JSON.parse(projectDetails.images)
    : [];

  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle
        pageTitle={projectDetails.title}
        pagesub={"Project"}
        img={img}
      />

      <section
        className="wpo-project-single-area section-padding"
        style={{
          backgroundColor: "#E6F7FF",
          paddingTop: "40px", // reduce vertical padding
          paddingBottom: "40px", // reduce vertical padding
        }}
      >
        <div className="container">
          <div
            className="row align-items-start"
            style={{
              padding: "40px 20px",
              borderTop: "1px solid #eee",
              borderBottom: "1px solid #eee",
            }}
          >
            {/* Project Images */}
            <div
              className="col col-lg-5 col-12"
              style={{ marginBottom: "20px" }}
            >
              <div
                className="project-single-slider"
                style={{ textAlign: "center" }}
              >
                {/* Main Image */}
                <div style={{ marginBottom: "15px" }}>
                  <Zoom>
                    <img
                      src={`${apiUrl}/storage/${mainImage}`}
                      alt={projectDetails.title}
                      style={{
                        width: "100%", // Fill full width of parent container
                        maxWidth: "100%", // Prevent overflow
                        height: "350px", // Increase height for larger display
                        objectFit: "cover", // Makes it cover fully, cropping if needed
                        objectPosition: "center", // Center the focus of the image
                        borderRadius: "20px",
                        border: "1px solid lightgray",
                        marginBottom: "15px",
                        backgroundColor: "#f5f5f5", // Optional: fills space for small images
                        boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                      }}
                    />
                  </Zoom>
                </div>

                {/* Thumbnails */}
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {/* Banner Thumbnail */}
                  <img
                    src={`${apiUrl}/storage/${projectDetails.banner}`}
                    alt="banner-thumb"
                    onClick={() => setMainImage(projectDetails.banner)}
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "cover",
                      borderRadius: "5px",
                      border:
                        mainImage === projectDetails.banner
                          ? "2px solid #000"
                          : "1px solid #ddd",
                      cursor: "pointer",
                      boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                    }}
                  />
                  {/* Extra Images */}
                  {imagesArray.map((img, index) => (
                    <img
                      key={index}
                      src={`${apiUrl}/storage/${img}`}
                      alt={`project-${index}`}
                      onClick={() => setMainImage(img)}
                      style={{
                        width: "90px",
                        height: "90px",
                        objectFit: "cover",
                        borderRadius: "5px",
                        border:
                          mainImage === img
                            ? "2px solid #000"
                            : "1px solid #ddd",
                        cursor: "pointer",
                        boxShadow: "0 10px 25px rgba(0, 0, 50, 0.6)",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Project Details */}
            <div className="col col-lg-7 col-12">
              <div className="project-details" style={{ padding: "0 20px" }}>
                <h2
                  style={{
                    fontSize: "28px",
                    marginBottom: "15px",
                    color: "#222",
                  }}
                >
                  {projectDetails.title}
                </h2>

                <p
                  style={{
                    fontSize: "16px",
                    lineHeight: "1.6",
                    marginBottom: "15px",
                    color: "#555",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: projectDetails.description,
                  }}
                />

                <ul
                  style={{
                    paddingLeft: "20px",
                    marginBottom: "20px",
                    color: "#444",
                    listStyleType: "disc",
                    listStylePosition: "outside",
                  }}
                >
                  {projectDetails.details && (
                    <li
                      dangerouslySetInnerHTML={{
                        __html: projectDetails.details,
                      }}
                    />
                  )}
                  {projectDetails.client_name && (
                    <li>Client: {projectDetails.client_name}</li>
                  )}
                  {projectDetails.project_manager && (
                    <li>Project Manager: {projectDetails.project_manager}</li>
                  )}
                  {projectDetails.location && (
                    <li>Location: {projectDetails.location}</li>
                  )}
                  {projectDetails.status && (
                    <li>Status: {projectDetails.status}</li>
                  )}
                  {projectDetails.start_date && (
                    <li>Start Date: {projectDetails.start_date}</li>
                  )}
                  {projectDetails.end_date && (
                    <li>End Date: {projectDetails.end_date}</li>
                  )}
                  {projectDetails.budget && (
                    <li>Budget: ${projectDetails.budget}</li>
                  )}
                  {projectDetails.details && (
                    <li>
                      <span>Details:</span>{" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: projectDetails.details,
                        }}
                      />
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          {/* Related Projects */}
          <div
            className="wpo-project-single-item"
            style={{ marginTop: "40px" }}
          >
            <RelatedProject currentProjectId={projectDetails.id} />
          </div>

          {/* Contact Form */}
          <div
            className="wpo-project-single-item"
            style={{ marginTop: "60px", textAlign: "center" }}
          >
            <div className="wpo-project-contact-area">
              <div className="wpo-contact-title">
                <h2
                  style={{
                    background: "linear-gradient(90deg, darkblue, #1E90FF)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontWeight: "700",
                    fontSize: "2rem",
                  }}
                >
                  Planning Your Next Industrial Project?
                </h2>
                <p style={{ color: "#4b5563", fontSize: "1.05rem" }}>
                  Let’s collaborate to deliver reliable, efficient, and
                  sustainable solutions.
                </p>
              </div>
              <div className="wpo-contact-form-area">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default ProjectSinglePage;
